// @flow
import { ClientReducerState } from 'common/models/internal/ClientReducerState';
import ClientActions from 'common/redux/actions/client';

const initialState = ClientReducerState.fromJS({});

export default (state: ClientReducerState = initialState, action: Object) => {
    switch (action.type) {
        case ClientActions.FETCH_CLIENT_START:
            return state.setIsLoading(true);

        case ClientActions.FETCH_CLIENT_COMPLETE:
            return state.setIsLoading(false);

        case ClientActions.FETCH_CLIENT_ERROR:
            return state.setIsLoading(false).setIsErrored(true);

        case ClientActions.INJECT_CLIENT: {
            const { clientId } = action.params;
            const updatedClientMap = state.clientMap.set(
                clientId,
                action.response
            );
            return state
                .setIsLoading(false)
                .setIsErrored(false)
                .setClientMap(updatedClientMap);
        }

        default:
            return state;
    }
};
